(ns practitest.frontend.testset2.instance-view-toggle
  (:require [clojure.string :as str]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.common.mixpanel :as mixpanel]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.overlay2 :as overlay2]
            [practitest.frontend.components2.buttons :as buttons]
            [practitest.frontend.components2.dropdown :as dropdown] 
            [practitest.frontend.testset2.events :as testset-events]
            [practitest.frontend.testset2.subs :as testset-subs]
            [re-frame.core :as re-frame]
            [reagent.core :as reagent]))

(defn should-reload-without-params? []
  (let [current-url (.. js/window -location -href)]
    (or (str/includes? current-url "filter")
        (str/includes? current-url "instance_view_mode"))))


(defn reload-without-params [_instance-view?]
  (let [current-url (.. js/window -location -href)
        url (js/URL. current-url)]
    ;; Use History API to update the URL without full page reload
    (.pushState (.-history js/window) #js {} "" (.. url -pathname))
    (re-frame/dispatch [::testset-events/set-instance-view-mode false])))


(defn instance-view-toggle-button []
  (let [open? (reagent/atom false)
        hide! (fn []
                (reset! open? false))
        toggle! (fn []
                  (swap! open? not))
        instance-view-mode? @(re-frame/subscribe [::testset-subs/instance-view-mode?])

        label (if instance-view-mode?
                (get-translation "testset.button.instance-view" "Instance View")
                (get-translation "testset.button.test-set-view" "Test Set View"))

        icon (if instance-view-mode?
               [icons/tree-mode]
               [icons/mux-testsets-runs])]
    (fn []
      [:div.align-items-center.instance-view-toggle
       [:span.tab-delimiter]
       [:div.instance-view-toggle-text.no-wrap (get-translation "testset.button.bt-pre-text-toggle-view" "You are in")]
       [overlay2/floating-ui-overlay
        {:on-request-close hide!
         :show? @open?
         :offset 0
         :placement "bottom-end"}
        [buttons/button
         {:tertiary? true
          :on-click toggle!
          :active? @open?
          :class "configure-fields-button hide-text"
          :text label
          :icon icon
          :end-icon [icons/mux-chevron-down2]}]

        [dropdown/dropdown-menu-body {:offset 0
                                      :placement "bottom"}

         [dropdown/dropdown-menu-item
          {:text (get-translation "testset.button.test-set-view" "Test Set View")
           :icon  [icons/mux-testsets-runs]
           :on-click #(do
                        (reset! open? false)
                        (mixpanel/track "Grid Actions" {"Action" "Test Set View"})
                        (if (should-reload-without-params?)
                          (reload-without-params false)
                          (re-frame/dispatch [::testset-events/set-instance-view-mode false])))}]

         [dropdown/dropdown-menu-item
          {:text (get-translation "testset.button.instance-view" "Instance View")
           :icon [icons/tree-mode]
           :on-click #(do
                        (reset! open? false)
                        (mixpanel/track "Grid Actions" {"Action" "Instance View"})
                        (if (should-reload-without-params?)
                          (reload-without-params true)
                          (re-frame/dispatch [::testset-events/set-instance-view-mode true])))}]]]])))
